import LayoutLegal from '@layouts/LayoutLegal';

const policyRoutes = [
    {
        path: 'privacy',
        name: 'privacy',
        component: () => import('@pages/legal/PagePrivacy'),
        meta: {
            title: 'titles.privacy_policy',
        },
    },
    {
        path: 'terms',
        name: 'terms',
        component: () => import('@pages/legal/PageTerms'),
        meta: {
            title: 'titles.terms_of_service',
        },
    },
    {
        path: 'cookies',
        name: 'cookies',
        component: () => import('@pages/legal/PageCookies'),
        meta: {
            title: 'titles.cookie_policy',
        },
    },
    {
        path: 'dpa',
        name: 'dpa',
        component: () => import('@pages/legal/PageDpa'),
        meta: {
            title: 'titles.dpa',
        },
    },
    {
        path: 'hipaa',
        name: 'hipaa',
        component: () => import('@pages/legal/PageHipaa'),
        meta: {
            title: 'titles.hipaa',
        },
    },
    {
        path: 'dsar',
        name: 'dsar',
        component: () => import('@pages/legal/PageDsar'),
        meta: {
            title: 'titles.dsar',
        },
    },

    {
        path: 'referral-program-terms',
        name: 'referral-program-terms',
        component: () => import('@pages/legal/PageReferralProgram'),
        meta: {
            title: 'titles.referral_program',
        },
    },
    {
        path: 'sub-processors',
        name: 'sub-processors',
        component: () => import('@pages/legal/PageSubProcessors'),
        meta: {
            title: 'titles.sub_processors',
        },
    },
];

function createPolicyRedirects() {
    return policyRoutes.map((route) => ({
        path: `/${route.path}`,
        name: route.name,
        redirect: { name: `policies-${route.name}` },
    }));
}

function createPolicyChildren(namePrefix = '') {
    return policyRoutes.map((route) => ({
        ...route,
        name: namePrefix ? `${namePrefix}${route.name}` : route.name,
    }));
}

export default [
    ...createPolicyRedirects(),
    {
        path: '/policies',
        component: LayoutLegal,
        children: [
            {
                path: '',
                redirect: { name: 'policies-terms' },
            },
            ...createPolicyChildren('policies-'),
        ],
    },
];
